<div class="modal-container">
    <button mat-button mat-dialog-close matTooltip="Cerrar" class="close-button">
        <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
    </button>
<mat-tab-group class="padding-modal" mat-stretch-tabs="false" [animationDuration]="'0'">
    <mat-tab label="Lista de Precios">
        <mat-dialog-content class="modal-content">
            <div class="relative flex flex-0 flex-col border-b py-4 sm:flex-row sm:items-center sm:justify-between">
                <div class="text-2xl font-extrabold tracking-tight">{{this.data?.code}} - {{this.data?.name}}</div>
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                        <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                        <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value, 'P')"/>
                    </mat-form-field>
                    <button mat-icon-button color="primary" (click)="openCreatePriceList()" matTooltip="Nuevo registro">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                </div>
            </div>
            <div class="flex flex-auto overflow-hidden flex-col">
                <div class="container mt-0 flex-auto flex-col overflow-x-auto">
                    <div class="sticky top-0 z-10 dark:bg-gray-900">
                        <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourcePriceList" 
                            matSort (matSortChange)="changeSort($event)"
                            matSortDisableClear multiTemplateDataRows>

                            <ng-container matColumnDef="unitMeasure">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">U.M.</th>
                                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                    <b>{{element?.unitMeasure?.code}}</b><br>
                                    {{element?.unitMeasure?.name || "-"}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="priceList">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Lista de Precios</th>
                                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                    <b>{{element?.priceList?.code}}</b><br>
                                    {{element?.priceList?.name || "-"}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="price">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    Precio {{ 'code' | companyCurrency: true }}
                                </th>
                                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                    {{ element?.price != null ? (element.price | number:'1.2-2') : '-' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="scalePrices">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Escalas</th>
                                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                    <mat-icon color="primary" matBadge="{{element?.scalePrices?.length || 0}}" matBadgeColor="accent"
                                        matBadgeSize="small" aria-hidden="false">local_atm
                                    </mat-icon>
                                </td>
                            </ng-container>
                            
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                                <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #actionMenu="matMenu">
                                        <button mat-menu-item (click)="openEditModal(element, 'P')">
                                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            <span>Editar Registro</span>
                                        </button>
                                        <button mat-menu-item (click)="openDeleteDialog(element, 'P')">
                                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            <span>Eliminar Registro</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsPriceList" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>                
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsPriceList" class="border-b"></tr>
                        </table>
                        <div *ngIf="this.dataSourcePriceList.data.length === 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">Lo sentimos, no hay registros para mostrar.
                        </div>
                    </div>
                </div>
                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
                      [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
                </div>
            </div>
        </mat-dialog-content>
    </mat-tab>
    <mat-tab label="Precio Liquidación">
        <mat-dialog-content class="modal-content">
            <div class="relative flex flex-0 flex-col border-b py-4 sm:flex-row sm:items-center sm:justify-between">
                <div class="text-2xl font-extrabold tracking-tight">{{this.data.code}} - {{this.data?.name}}</div>
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                        <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                        <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value, 'L')"/>
                    </mat-form-field>
                    <button mat-icon-button color="primary" (click)="openCreateLiquidationList()" matTooltip="Nuevo registro">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                </div>
            </div>
            <div class="flex flex-auto overflow-hidden flex-col">
                <div class="container mt-0 flex-auto flex-col overflow-x-auto">
                    <div class="sticky top-0 z-10 dark:bg-gray-900">
                        <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceLiquidationList" 
                            matSort (matSortChange)="changeSortLiquidation($event)">
                            <ng-container matColumnDef="field8">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Rango</th>
                                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                    {{element?.field8 || "-"}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="price">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    Precio {{ 'code' | companyCurrency: true}}
                                </th>
                                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                    {{ element?.price != null ? (element.price | number:'1.2-2') : '-' }}
                                </td>
                            </ng-container>
                            
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                                <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #actionMenu="matMenu">
                                        <button mat-menu-item (click)="openEditModal(element, 'L')">
                                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            <span>Editar Registro</span>
                                        </button>
                                        <button mat-menu-item (click)="openDeleteDialog(element, 'L')">
                                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            <span>Eliminar Registro</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsLiquidationList" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>                
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsLiquidationList" class="border-b"></tr>
                        </table>
                        <div *ngIf="this.dataSourceLiquidationList.data.length === 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">Lo sentimos, no hay registros para mostrar.
                        </div>
                    </div>
                </div>
                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItemsLiquidation"
                      [pageSize]="pageSizeLiquidation" (page)="changePageLiquidation($event)"></mat-paginator>
                </div>
            </div>
        </mat-dialog-content>
    </mat-tab>
</mat-tab-group>
</div>

<!-- Modales -->
<ng-template #addPriceListModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
    <mat-dialog-content class="modal-content">
        <form #createPriceForm="ngForm">
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Organización Ventas</mat-label>
                    <mat-select [(ngModel)]="currentCreatePriceList.distributionChainId" name="distributionChainId" required>
                        @for (item of salesOrganizationList; track item) {
                        <mat-option [value]="item._id">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Lista de Precios</mat-label>
                    <mat-select [(ngModel)]="currentCreatePriceList.priceListId" name="priceListId" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchPriceList" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsPriceList($event)" placeholderLabel="Buscar precio de lista..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (price of listFilterPriceList; track price) {
                        <mat-option [value]="price._id">
                            <b>{{price.code}}</b> - {{price.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material</mat-label>
                    <mat-select [(ngModel)]="currentCreatePriceList.itemId" name="itemId" (selectionChange)="getUnitMeasureList()" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialList; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida</mat-label>
                    <mat-select [(ngModel)]="currentCreatePriceList.unitMeasureId" name="unitMeasureId" required>
                        @for (unit of unitMeasureList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
                    <mat-date-range-input [formGroup]="rangeCreatePriceList" [rangePicker]="picker">
                      <input matStartDate formControlName="start" placeholder="Fecha Inicio">
                      <input matEndDate formControlName="end" placeholder="Fecha Fin">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <!-- <mat-form-field class="w-full">
                    <mat-label>Desde</mat-label>
                    <input matInput [matDatepicker]="dateStart" [(ngModel)]="currentCreatePriceList.dateStart" name="dateStart" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateStart"></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>Hasta</mat-label>
                    <input matInput [matDatepicker]="dateEnd" [(ngModel)]="currentCreatePriceList.dateEnd" name="dateEnd" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateEnd"></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                </mat-form-field> -->

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Moneda</mat-label>
                    <mat-select [(ngModel)]="currentCreatePriceList.currencyId" name="currencyId" required>
                        @for (currency of listFilterCurrency; track currency) {
                        <mat-option [value]="currency._id">
                            <b>{{currency.code}}</b> - {{currency.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Precio</mat-label>
                    <input matInput type="number" [(ngModel)]="currentCreatePriceList.price" name="price" required>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="currentCreatePriceList"
            [disabled]="!createPriceForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #addLiquidationListModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
    <mat-dialog-content class="modal-content">
        <form #createLiquidationForm="ngForm">
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Organización Ventas</mat-label>
                    <mat-select [(ngModel)]="currentCreateLiquidationList.distributionChainId" name="distributionChainId" required>
                        @for (item of salesOrganizationList; track item) {
                        <mat-option [value]="item._id">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Lista de Precios</mat-label>
                    <mat-select [(ngModel)]="currentCreateLiquidationList.priceListId" name="priceListId" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchPriceList" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsPriceList($event)" placeholderLabel="Buscar precio de lista..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (price of listFilterPriceList; track price) {
                        <mat-option [value]="price._id">
                            <b>{{price.code}}</b> - {{price.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Rango</mat-label>
                    <mat-select [(ngModel)]="currentCreateLiquidationList.rangeId" name="rangeId" required>
                        @for (item of rangeList; track item) {
                        <mat-option [value]="item.code">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>                    
                </mat-form-field>
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material</mat-label>
                    <mat-select [(ngModel)]="currentCreateLiquidationList.itemId" name="itemId" (selectionChange)="getUnitMeasureList()" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialList; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida</mat-label>
                    <mat-select [(ngModel)]="currentCreateLiquidationList.unitMeasureId" name="unitMeasureId" required>
                        @for (unit of unitMeasureList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Moneda</mat-label>
                    <mat-select [(ngModel)]="currentCreateLiquidationList.currencyId" name="currencyId" required>
                        @for (currency of listFilterCurrency; track currency) {
                        <mat-option [value]="currency._id">
                            <b>{{currency.code}}</b> - {{currency.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Precio</mat-label>
                    <input matInput type="number" [(ngModel)]="currentCreateLiquidationList.price" name="price" required>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
                    <mat-date-range-input [formGroup]="rangeCreateLiquidationList" [rangePicker]="picker">
                      <input matStartDate formControlName="start" placeholder="Fecha Inicio">
                      <input matEndDate formControlName="end" placeholder="Fecha Fin">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <!-- <mat-form-field class="w-full">
                    <mat-label>Desde</mat-label>
                    <input matInput [matDatepicker]="dateStart" [(ngModel)]="currentCreateLiquidationList.dateStart" name="dateStart" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateStart"></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>Hasta</mat-label>
                    <input matInput [matDatepicker]="dateEnd" [(ngModel)]="currentCreateLiquidationList.dateEnd" name="dateEnd" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateEnd"></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                </mat-form-field> -->

            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="currentCreateLiquidationList"
            [disabled]="!createLiquidationForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #editPriceListModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
    <mat-dialog-content class="modal-content">
        <form #editPriceForm="ngForm">
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Organización Ventas</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePriceList.field1" name="field1" required>
                        @for (item of salesOrganizationList; track item) {
                        <mat-option [value]="item._id">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Lista de Precios</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePriceList.field4" name="field4" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchPriceList" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsPriceList($event)" placeholderLabel="Buscar precio de lista..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (price of listFilterPriceList; track price) {
                        <mat-option [value]="price._id">
                            <b>{{price.code}}</b> - {{price.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePriceList.field6" name="field6" (selectionChange)="getUnitMeasureList()" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialList; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePriceList.field7" name="field7" required>
                        @for (unit of unitMeasureList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
                    <mat-date-range-input [formGroup]="rangeUpdatePriceList" [rangePicker]="picker">
                      <input matStartDate formControlName="start" placeholder="Fecha Inicio">
                      <input matEndDate formControlName="end" placeholder="Fecha Fin">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <!-- <mat-form-field class="w-full">
                    <mat-label>Desde</mat-label>
                    <input matInput [matDatepicker]="dateStart" [(ngModel)]="currentUpdatePriceList.dateStart" name="dateStart" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateStart"></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>Hasta</mat-label>
                    <input matInput [matDatepicker]="dateEnd" [(ngModel)]="currentUpdatePriceList.dateEnd" name="dateEnd" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateEnd"></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                </mat-form-field> -->


                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Moneda</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePriceList.field5" name="field5" required>
                        @for (currency of listFilterCurrency; track currency) {
                        <mat-option [value]="currency._id">
                            <b>{{currency.code}}</b> - {{currency.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Precio</mat-label>
                    <input matInput type="number" [(ngModel)]="currentUpdatePriceList.price" name="price" required>
                </mat-form-field>
            </div>
        </form>
        <app-table-price-list [data]="currentUpdatePriceList"  (materialPriceChange)="updateFormPriceList($event)"></app-table-price-list>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="currentUpdatePriceList"
            [disabled]="!editPriceForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #editLiquidationModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
    <mat-dialog-content class="modal-content">
        <form #updateLiquidationForm="ngForm">
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Organización Ventas</mat-label>
                    <mat-select [(ngModel)]="currentUpdateLiquidationList.field1" name="field1" required>
                        @for (item of salesOrganizationList; track item) {
                        <mat-option [value]="item._id">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Lista de Precios</mat-label>
                    <mat-select [(ngModel)]="currentUpdateLiquidationList.field4" name="field4" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchPriceList" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsPriceList($event)" placeholderLabel="Buscar precio de lista..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (price of listFilterPriceList; track price) {
                        <mat-option [value]="price._id">
                            <b>{{price.code}}</b> - {{price.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Rango</mat-label>
                    <mat-select [(ngModel)]="currentUpdateLiquidationList.field8" name="field8" required>
                        @for (item of rangeList; track item) {
                        <mat-option [value]="item.code">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>                    
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material</mat-label>
                    <mat-select [(ngModel)]="currentUpdateLiquidationList.field6" name="field6" (selectionChange)="getUnitMeasureList()" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialList; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida</mat-label>
                    <mat-select [(ngModel)]="currentUpdateLiquidationList.field7" name="field7" required>
                        @for (unit of unitMeasureList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Moneda</mat-label>
                    <mat-select [(ngModel)]="currentUpdateLiquidationList.field5" name="field5" required>
                        @for (currency of listFilterCurrency; track currency) {
                        <mat-option [value]="currency._id">
                            <b>{{currency.code}}</b> - {{currency.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Precio</mat-label>
                    <input matInput type="number" [(ngModel)]="currentUpdateLiquidationList.price" name="price" required>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
                    <mat-date-range-input [formGroup]="rangeUpdateLiquidationList" [rangePicker]="picker">
                      <input matStartDate formControlName="start" placeholder="Fecha Inicio">
                      <input matEndDate formControlName="end" placeholder="Fecha Fin">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <!-- <mat-form-field class="w-full">
                    <mat-label>Desde</mat-label>
                    <input matInput [matDatepicker]="dateStart" [(ngModel)]="currentUpdateLiquidationList.dateStart" name="dateStart" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateStart"></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>Hasta</mat-label>
                    <input matInput [matDatepicker]="dateEnd" [(ngModel)]="currentUpdateLiquidationList.dateEnd" name="dateEnd" required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateEnd"></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                </mat-form-field> -->
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="currentUpdateLiquidationList"
            [disabled]="!updateLiquidationForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #deleteDialog>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
    </mat-dialog-actions>
</ng-template>